import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateSurgeriesCompletion(
  patient: Patient | null | undefined,
) {
  const hasSurgeries = (patient as any)?.medicalHistory?.hasSurgeries;
  const surgeries = (patient as any)?.medicalHistory?.surgeries;

  const answeredFlag = hasSurgeries !== undefined && hasSurgeries !== null;
  const hasAny = Array.isArray(surgeries) && surgeries.length > 0;

  // If they answered no, count as complete (n/a for list)
  const completed = answeredFlag
    ? 1 + (hasSurgeries ? (hasAny ? 1 : 0) : 1)
    : 0;
  const percent = completed / 2;
  const label = answeredFlag
    ? hasSurgeries
      ? hasAny
        ? "2/2 answered"
        : "1/2 answered"
      : "2/2 answered"
    : "0/2 answered";

  return { percent, label, completed, total: 2 };
}
